import { render, staticRenderFns } from "./cv-switcher.vue?vue&type=template&id=2e4f1159&"
import script from "./cv-switcher.vue?vue&type=script&lang=js&"
export * from "./cv-switcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports